import React from 'react';
import { WifiOff, RefreshCw } from 'lucide-react';

interface ConnectionErrorProps {
  onRetry: () => Promise<boolean>;
  isRetrying: boolean;
}

export default function ConnectionError({ onRetry, isRetrying }: ConnectionErrorProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 max-w-md w-full text-center">
        <WifiOff className="w-16 h-16 text-red-500 mx-auto mb-6" />
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
          Connection Error
        </h1>
        <p className="text-gray-600 dark:text-gray-300 mb-6">
          Unable to connect to the server. Please check your internet connection and try again.
        </p>
        <button
          onClick={onRetry}
          disabled={isRetrying}
          className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isRetrying ? (
            <>
              <RefreshCw className="w-5 h-5 animate-spin" />
              Reconnecting...
            </>
          ) : (
            <>
              <RefreshCw className="w-5 h-5" />
              Try Again
            </>
          )}
        </button>
      </div>
    </div>
  );
}